<template>
  <div class="teammember" ref="container">
    <div class="list">
      <div
        class="item acea-row row-between-wrapper"
        v-for="(item, index) in userList"
        :key="index"
      >
        <div class="left acea-row">
          <img class="" :src="item.user.avatar" />
          <div class="infos">
            <div class="nickname line1">{{ item.user.nickname }}</div>
            <div class="luckynum">参团编号：{{ item.identifier }}</div>
          </div>
          <div class="status" v-if="ispre && item.user.is_zj">拼中</div>
        </div>
        <div class="right">{{ item.pay_time }}</div>
      </div>
      <div class="nolist">列表为空~</div>
    </div>
  </div>
</template>
<script>
import { ptUserList, ptUpUserList } from "@api/pink.js";
export default {
  name: "teammember",
  data() {
    return {
      page: 1,
      limit: 20,
      id: 0,
      ispre: 0,
      loading: false, //是否加载中
      loadend: false, //是否加载完毕
      userList: []
    };
  },
  mounted() {
    if (this.$route.params.id) {
      this.id = this.$route.params.id;
      this.ispre = this.$route.params.ispre;
    }
    if (this.ispre == 1) {
      this.getptUpUserList();
    } else {
      this.getptUserList();
    }
    this.$scroll(this.$refs.container, () => {
      if (this.ispre == 1) {
        !this.loading && this.getptUpUserList();
      } else {
        !this.loading && this.getptUserList();
      }
    });
  },
  methods: {
    getptUserList() {
      let data = {
        id: this.id,
        page: this.page,
        limit: this.limit
      };
      if (this.loading || this.loaded) return;
      this.loading = true;
      ptUserList(data)
        .then(res => {
          console.log(res);
          this.userList = this.userList.concat(res.data);
          this.page++;
          this.loaded = res.data.length < this.limit;
          this.loading = false;
        })
        .catch(res => {
          console.log(res);
        });
    },
    getptUpUserList() {
      let data = {
        id: this.id,
        page: this.page,
        limit: this.limit
      };
      if (this.loading || this.loaded) return;
      this.loading = true;
      ptUpUserList(data)
        .then(res => {
          console.log(res);
          this.userList = this.userList.concat(res.data);
          this.page++;
          this.loaded = res.data.length < this.limit;
          this.loading = false;
        })
        .catch(res => {
          console.log(res);
        });
    }
  }
};
</script>
<style lang="scss" scoped>
.list {
  width: 100%;
  padding: 0 2.57vw;
  .item {
    background-color: #ffffff;
    height: 17.87vw;
    padding: 0 3.2vw 0 5.07vw;
    .left {
      align-items: center;
      img {
        width: 9.87vw;
        height: 9.87vw;
        border-radius: 50%;
      }
      .infos {
        max-width: 30vw;
        margin: 0 4vw;
        .nickname {
          color: #333333;
          font-size: 3.73vw;
        }
        .luckynum {
          color: #999999;
          font-size: 3.2vw;
        }
      }
      .status {
        width: 10.67vw;
        height: 4.53vw;
        font-size: 3.2vw;
        line-height: 4.53vw;
        color: #ffffff;
        background: linear-gradient(135deg, #ff4a2d, #ff4142);
        text-align: center;
        border-radius: 2vw;
      }
    }
    .right {
      font-size: 2.93vw;
      color: #999999;
    }
  }
  .nolist {
    text-align: center;
    line-height: 10vw;
    color: #999999;
    font-size: 4vw;
  }
}
</style>
